import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-spares',
  standalone: true,
  imports: [RouterOutlet, TitledPageComponent],
  templateUrl: './spares.component.html',
  styleUrl: './spares.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SparesComponent {}
